module.exports = __webpack_public_path__ + "img/940x1410_0xc0a839a4_6912462991475681269.jpeg";